import "./AppFooter.css";
// We don't show <Languages> now.
//import Languages from "./../Languages/Languages";
import TabsPanel from "../TabsPanel/TabsPanel";
import LegalDocumentsPanel from "../legal/LegalDocumentsPanel/LegalDocumentsPanel";
import { useTabs } from "hooks/useTabs";

/**
 * A default page's footer with a copyright and navigation links.
 * It also supports languages panel but it's disabled for now.
 */

type Props = {
  /** A callback fired when user clicks on one of Language links. */
  onLangChange: (lang: string) => void;
  /** A language that is currently used. */
  currentLanguage: string;
  /** A custom CSS style that can be applied to footer container. */
  style: any;
  /** AIndicates whether browser window is small or not. */
  smallWindow: boolean;
  /** A custom CSS class name that can be applied to navigation link components. */
  navLinkClassName: string;
};

export default function AppFooter(props: Props) {
  const tabs = useTabs();
  return (
    <div className="app-footer" style={props.style}>
      <div className="footer-content">
        <TabsPanel footer tabs={tabs} linkClassName={props.navLinkClassName} />
        <div className="terms-panel">
          <LegalDocumentsPanel />
        </div>
        <div>
          <div className="copyright-wrapper">
            <span className="copyright">
              Copyright Talaera {new Date().getFullYear()}. All rights reserved.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
